/**
 * @copyright Copyright 2015-2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "mw-form/Label",
    "MW/toolstrip/mixins/property/TypeMixin",
    "MW/toolstrip/mixins/property/IconMixin",
    "MW/toolstrip/mixins/property/IconOverrideMixin",
    "MW/toolstrip/mixins/property/DescriptionOverrideMixin",
    "MW/toolstrip/mixins/property/TextMixin",
    "MW/toolstrip/mixins/property/TextOverrideMixin",
    "mw-form/mixins/property/ShortcutMixin",
    "mw-form/mixins/mixinDependencyValidator"
], function (declare, Label, TypeMixin, IconMixin, IconOverrideMixin, DescriptionOverrideMixin, TextMixin,
             TextOverrideMixin, ShortcutMixin, mixinDependencyValidator ) {

    return declare(mixinDependencyValidator.validate([Label, TypeMixin, IconMixin, IconOverrideMixin, DescriptionOverrideMixin,
        TextMixin, TextOverrideMixin, ShortcutMixin]), {
        visualFamily: "default",
        height: 22,

        /**
         * Override from DisabledMixin to prevent tab index from being added, since Label wants to be non-focusable
         * @private
         * @override
         */
        _setTabIndexOnNode: function () {
            // No-op
        }
    });

});
